
import { AppBar, Button, debounce, Dialog, DialogActions, DialogContent, DialogContentText, Divider, Grid, TextField, Toolbar, Typography } from "@mui/material"
import { useAppSelector } from "../../../../hooks/store-hooks"
import { usePerfilService } from "../../../../../use-cases/perfil"
import CloseIcon from '@mui/icons-material/Close';
import { formatCnpj } from "../../../../../utils";
import { useEffect, useState } from "react";
import { useNavigationService } from "../../../../../use-cases/navigation";
import { useUIService } from "../../../../../use-cases/ui";

export const FormCreatePerfil = () => {
  // State
  const { createPerfilForm, openCreatePerfilForm, clienteSelecionado } = useAppSelector((state) => state.perfil)
  // Use State
  const [loading, setLoading] = useState(true)
  // Service
  const { setOpenCreatePerfilForm, setCreatePerfilFormName, setCreatePerfilFormIdCliente, createPerfil } = usePerfilService()
  const { navigateTo } = useNavigationService()
  const { setAlert } = useUIService()
  useEffect(() => {
    setLoading(false)
  }, [])
  useEffect(() => {
    if (!loading) {
      if (!clienteSelecionado) {
        setAlert({
          message: 'Selecione um cliente para prosseguir com a criação do perfil',
          type: 'error'
        })
        navigateTo({
          route: '/dashboard/cadastro/perfil'
        })
      } else {
        setCreatePerfilFormIdCliente({
          idCliente: clienteSelecionado.IdCliente
        })
      }
    }
  }, [clienteSelecionado, loading, navigateTo, setAlert, setCreatePerfilFormIdCliente])
  // Functions
  const handleClose = () => {
    setOpenCreatePerfilForm({
      open: false
    })
  }


  return (
    <>
      {
        !loading ?
          clienteSelecionado && (
            <Dialog
              open={openCreatePerfilForm}
              onClose={handleClose}
              scroll={'paper'}
              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
              fullWidth
            >
              <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                  <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
                    Criar perfil
                  </Typography>
                  <Button
                    color="inherit"
                    startIcon={<>
                      <CloseIcon />
                    </>}
                    onClick={handleClose}
                    aria-label="close"
                  >
                    Fechar
                  </Button>
                </Toolbar>
              </AppBar>
              <DialogContent dividers={true}>
                <DialogContentText id="scroll-dialog-description" tabIndex={-1}></DialogContentText>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      defaultValue={createPerfilForm.fields.nome}
                      onChange={debounce((e) => {
                        setCreatePerfilFormName({
                          nome: e.target.value
                        })
                      }, 500)}
                      error={Boolean(createPerfilForm.touched && createPerfilForm.errors.find(item => item.key === 'nome'))}
                      helperText={createPerfilForm.errors.find(item => item.key === 'nome')?.message}
                      name="name"
                      fullWidth
                      id="name"
                      label="Nome do Perfil"
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" textAlign={'center'} fontWeight={'bold'}>Cliente selecionado</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" textAlign={'left'}><strong>CNPJ:</strong> {formatCnpj(clienteSelecionado?.CNPJ ?? '')}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" textAlign={'left'}><strong>Razão Social:</strong>{clienteSelecionado?.RazaoSocial}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" textAlign={'left'}><strong>Login Cliente:</strong> {clienteSelecionado?.LoginCliente}</Typography>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={createPerfil} variant="contained">Criar</Button>
              </DialogActions>
            </Dialog>
          )
          : null}
    </>
  )
}
